import React from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import './PageLayout.scss'
import { isUserStaff, isUserAdmin } from '../../lib/helpers'
import axios from 'axios'
import { BeatLoader } from 'react-spinners'
import constants from '../../lib/constants'

class PageLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    user: PropTypes.any,
    router: PropTypes.shape({}),
    logout: PropTypes.func,
    getUser: PropTypes.func,
  }

  constructor (props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  componentDidMount () {
    const { getUser } = this.props
    window.addEventListener('message', this.handleIframeTask)

    try {
      getUser()
      this.setState({
        loading: false
      })
    } catch (e) {
    }
  }

  handleIframeTask = (e) => {
    const { getUser, router } = this.props
    if (e.origin !== 'https://athelas.com') {
      return
    }
    if (e.data.hasOwnProperty('authToken')) {
      if (e.data.authToken) {
        localStorage.setItem('authToken', e.data.authToken)
        axios.defaults.headers.common['Authorization'] = `Bearer ${e.data.authToken}`
        try {
          getUser()
          this.setState({
            loading: false
          })
        } catch (e) {
          if (e.response.status === 401 || e.response.status === 409) {
            if (constants.ENABLE_SSO) {
              window.location.href = 'https://www.athelas.com/sso/login#' + encodeURIComponent(window.location.href)
            } else {
              console.log("HEYO")
              router.push('/login')
              this.setState({ loading: false })
            }
          }
        }
      } else {
        if (constants.ENABLE_SSO) {
          window.location.href = 'https://www.athelas.com/sso/login#' + encodeURIComponent(window.location.href)
        } else {
          console.log("HEYO")
          //router.push('/login')
          this.setState({ loading: false })
        }
      }
    }
  }

  logout = () => {
    const { logout } = this.props
    logout()
    var target = 'https://www.athelas.com/sso/logout#' + encodeURIComponent(window.location.href)
    window.location.href = target
  }

  render () {
    const { user, children } = this.props

    const isStaff = isUserStaff(user)
    const isAdmin = isUserAdmin(user)

    return (
      <div>
        <iframe src='https://www.athelas.com/sso/login' style={{ display: 'none' }} />
        <nav className='navbar navbar-expand-lg navbar-light bg-light'>
          <Link className='navbar-brand' to={'/'}>Athelas Dashboard</Link>
          <button
            className='navbar-toggler'
            type='button'
            data-toggle='collapse'
            data-target='#navbarSupportedContent'
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon' />
          </button>
          <div className='collapse navbar-collapse' id='navbarSupportedContent'>
            <ul className='navbar-nav nav' style={{ width: '100%' }}>
              { isStaff
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/versions'}>
                    Version Management
                  </Link>
                </div>
              </li> : ''}
              { isAdmin
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/clinic-tools'}>
                    Clinic Tools
                  </Link>
                </div>
              </li> : ''}
              { isAdmin
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/qc/list'}>
                    QCs
                  </Link>
                </div>
              </li> : ''}
              { isAdmin
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/client-versions'}>
                    Client Versions
                  </Link>
                </div>
              </li> : ''}
              { isAdmin
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/claims'}>
                    Claims
                  </Link>
                </div>
              </li> : ''}
              { isAdmin
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/concierge'}>
                    Concierge
                  </Link>
                </div>
              </li> : ''}
              <li className='nav-item' style={{ marginLeft: 'auto' }}>
                <div className='nav-link' onClick={this.logout} style={{ cursor: 'pointer' }}>
                  Logout
                </div>
              </li>
            </ul>
          </div>

        </nav>
        <div className='container-fluid text-center'>
          { this.state.loading ? <BeatLoader /> : (
            <div className='page-layout__viewport'>
              {children}
            </div>
            )
          }
        </div>
      </div>
    )
  }
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js